export default class VideoSection {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.mBP = 760; //mobile breakpoint size
        this.videosLoaded = 0;
        this.videosOnShow = 2;
        this.baseVideosOnShow = 2;
        this.prevWW = '';
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.videosLoaded = this.passedElement.getAttribute('data-videos-length');
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        //Query your elements here
        this.videos = this.passedElement.querySelectorAll('.video-container');
        this.loadMoreBtn = this.passedElement.querySelector('.load--more');
        if ( window.innerWidth < this.mBP ) { this.hideExtraVideos(); }
    }

    removeInlineStyle = (elm, property) => {
        if (elm.style.removeProperty) {
            elm.style.removeProperty(property);
        } else {
            elm.style.removeAttribute(property);
        }
    }

    hideExtraVideos = () => {
        this.videos.forEach( elm => {
            elm.getAttribute('data-video') <= this.videosOnShow 
            ? elm.style.display = 'block' 
            : elm.style.display = 'none'; 
        });
        this.videosOnShow >= this.videosLoaded 
        ? this.loadMoreBtn.style.display = 'none'
        : this.removeInlineStyle(this.loadMoreBtn, 'display');
    }

    resetVideos = () => {
        this.videosOnShow = this.baseVideosOnShow;
        this.removeInlineStyle(this.loadMoreBtn, 'display');
        this.videos.forEach(elm => {
            elm.style.display = 'block'; 
        });
    }

    addEventListeners = () => {
        //Add all event listeners bellow

        this.loadMoreBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if ( this.videosOnShow < this.videosLoaded ) {
                this.videosOnShow = this.videosOnShow + 2;
                this.hideExtraVideos();
            }
        });

        window.addEventListener('resize', () => {
            if ( this.prevWW > this.mBP && window.innerWidth < this.mBP  ) {
                this.hideExtraVideos();
            }
            if ( this.prevWW < this.mBP && window.innerWidth > this.mBP ) {
                this.resetVideos();
            }
            this.prevWW = window.innerWidth;
        });
    }

}